import React from 'react';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';

import { rowsPerPageOptions } from '../../config';
import { ColumnDef } from '@tanstack/react-table';
import { IconComponent, icons } from '../../componets/icons';
import { IFormInputPropsFilter } from '../../componets/interfaces/formInputPropsFilter';
import ListComponet from '../../componets/list';
import { ImperativeHandleAccessedByParentListComponent } from '../../componets/interfaces/listProps';
import { IFormSettinsProps } from '../../componets/interfaces/formProps';

// interface Data {
//     description?: string;
//     id: string;
// }

// interface IDataQuery {
//     description: string;
// }

// const defaultValues = {};

// const settings = {
//     pathRegister: paths.companyRegister,
//     pathList: paths.company,
//     apiPath: 'company',
//     permissionAdmin: null,
//     title: 'Empresas',
// };

// const ProductList: React.FC = () => {
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(0);
//     const [rows, setRows] = useState<Data[]>([]);
//     const [total, setTotal] = useState<number>(0);
//     const [toggleSearch, setToggleSearch] = useState<boolean>(false);
//     const [updateRows, setUpdateRows] = useState<boolean>(false);
//     const [openModalDelete, setOpenModalDelete] = useState(false);
//     const [idDelete, setIdDelete] = useState<string>('');

//     const history = useHistory();
//     const { search } = useLocation();
//     const { setOpenLoading } = useContextGlobal();
//     const { addToast } = useToast();

//     const { control, getValues } = useForm<IDataQuery>({
//         defaultValues,
//     });

//     const loadRows = async (queryString: string): Promise<void> => {
//         setOpenLoading(true);
//         try {
//             const response = await api.get(
//                 `${settings.apiPath}?${queryString}`,
//             );
//             setRows(response.data.data);
//             setTotal(response.data.count);
//             setOpenLoading(false);
//             if (updateRows) {
//                 setUpdateRows(false);
//             }
//         } catch (error) {
//             const { messageResponse, typeFeedback } = handleExceptionMessage(error);
//             addToast({
//                 type: typeFeedback,
//                 title: message.error.selectAll,
//                 description: messageResponse,
//             });
//             setOpenLoading(false);
//         }
//     };

//     const handleClick = (id: string) => {
//         handleEdit(id);
//     };

//     const QUERY_DEFAULT = `page=1&limit=${rowsPerPageOptions[0]}`;

//     const inputsFilter: IFormInputPropsFilter[] = [
//         {
//             typeInput: 'text',
//             name: 'description',
//             control: control,
//             label: 'Descrição',
//             size: 'small',
//             variant: 'standard',
//             handleOnKeyPress: (data: any) => {
//                 if (data.charCode === 13) {
//                     handleByOnKeyPressEnterNewQuery(true);
//                 }
//             },
//         },
//     ];

//     // HANDLER LOAD NEW QUERY FILTER
//     const handleByOnKeyPressEnterNewQuery = (
//         defaultFilter: boolean | undefined,
//     ) => {
//         const queryObj = queryToObj(search.replace('?', ''));

//         const newQuery = {
//             ...queryObj,
//             'company.description': getValues('description'),
//             page: 1,
//         };
//         const query = objToQuery(newQuery);
//         history.push(`?${query}`);
//         loadRows(query);

//         if (window.screen.width < 900) {
//             setToggleSearch(false);
//         }
//     };

//     const handleEdit = (id: string) => {
//         history.push(`${settings.pathRegister}/${id}`);
//     };
//     const handleDelete = async (id: string) => {
//         setOpenLoading(true);

//         try {
//             await api.delete(`${settings.apiPath}/${id}`);
//             addToast({
//                 type: 'success',
//                 title: message.success.delete,
//                 description: '',
//             });
//             setPage(0);
//             setRowsPerPage(rowsPerPageOptions[0]);
//             setUpdateRows(true);
//         } catch (error: any) {
//             const { messageResponse, typeFeedback } = handleExceptionMessage(error);
//             setOpenLoading(false);
//             addToast({
//                 type: typeFeedback,
//                 title: message.error.delete,
//                 description: messageResponse,
//             });
//         }
//     };

//     const handleConfirmeDelete = async (confirm: boolean) => {
//         if (confirm) {
//             setOpenModalDelete(false);
//             handleDelete(idDelete);
//             setIdDelete('');
//         } else {
//             setOpenModalDelete(false);
//             setIdDelete('');
//         }
//     };

//     const columnsTable = React.useMemo<ColumnDef<Data>[]>(
//         () => [
//             {
//                 id: 'select',
//                 header: () => (
//                     <TableCell align={'left'} padding={'normal'}>
//                         Descrição
//                     </TableCell>
//                 ),
//                 cell: ({ row }: any) => {
//                     return (
//                         <TableCell
//                             align="left"
//                             key={row.id}
//                             onClick={() => handleClick(row.original.id)}>
//                             {row.original?.description}
//                         </TableCell>
//                     );
//                 },
//             },
//             {
//                 id: 'select',
//                 header: ({ table }: any) => <TableCell align="center" />,
//                 cell: ({ row }: any) => (
//                     <TableCell align="right">
//                         <IconButton onClick={() => handleEdit(row.original.id)}>
//                             <IconComponent icon={icons.ModeEdit} />
//                         </IconButton>
//                         <IconButton
//                             onClick={() => {
//                                 setIdDelete(row.original.id);
//                                 setOpenModalDelete(true);
//                             }}>
//                             <IconComponent icon={icons.Delete} />
//                         </IconButton>
//                     </TableCell>
//                 ),
//             },
//         ],
//         [],
//     );

//     return (
//         <div className="principal-container-permission">
//             <AlertDialog
//                 handleConfirmation={handleConfirmeDelete}
//                 open={openModalDelete}
//             />
//             <Box className={toggleSearch ? 'container-box' : ''}>
//                 <Paper sx={{ width: '100%', mb: 2 }}>
//                     <div className="header-list">
//                         <div className="header-list-title">
//                             <Typography
//                                 sx={{ flex: '1 1 100%' }}
//                                 variant="h6"
//                                 id="tableTitle"
//                                 component="div">
//                                 {settings.title}
//                             </Typography>
//                         </div>
//                         <div className="header-list-search">
//                             <Stack
//                                 spacing={1}
//                                 direction="row"
//                                 width={'100%'}
//                                 justifyContent="space-between"
//                                 alignItems="flex-end">
//                                 <FormInputText
//                                     name={inputsFilter[0].name}
//                                     control={inputsFilter[0].control}
//                                     label={inputsFilter[0].label}
//                                     size={inputsFilter[0].size}
//                                     variant={inputsFilter[0].variant}
//                                     handleOnKeyPress={
//                                         inputsFilter[0].handleOnKeyPress
//                                     }
//                                 />
//                             </Stack>
//                         </div>
//                     </div>
//                     <Typography
//                         sx={{
//                             pl: { xs: 1, sm: 2 },
//                             pr: { xs: 1, sm: 1 },
//                         }}>
//                         <FormButton
//                             label={'Novo'}
//                             typeButton="addRegister"
//                             onClick={() => history.push(settings.pathRegister)}
//                         />
//                     </Typography>
//                     <TableGeneric
//                         data={rows}
//                         columns={columnsTable}
//                         minWidth={650}
//                     />
//                     <TablePagination
//                         rowsPerPageOptions={rowsPerPageOptions}
//                         component="div"
//                         count={total}
//                         labelRowsPerPage={'Linhas por página'}
//                         labelDisplayedRows={defaultLabelDisplayedRows}
//                         rowsPerPage={rowsPerPage}
//                         page={total > 0 ? page : 0}
//                         onPageChange={(event: unknown, newPage: number) =>
//                             handleChangePage(
//                                 event,
//                                 newPage,
//                                 setPage,
//                                 history,
//                                 loadRows,
//                             )
//                         }
//                         onRowsPerPageChange={(
//                             event: React.ChangeEvent<HTMLInputElement>,
//                         ) =>
//                             handleChangeRowsPerPage(
//                                 event,
//                                 setRowsPerPage,
//                                 setPage,
//                                 history,
//                                 loadRows,
//                             )
//                         }
//                     />
//                 </Paper>
//             </Box>

//             <QueryStringGlobal
//                 setRowsPerPage={setRowsPerPage}
//                 setPage={setPage}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 implementationLoadRows={loadRows}
//                 updateRows={updateRows}
//                 setUpdateRows={setUpdateRows}
//                 queryDefault={QUERY_DEFAULT}
//                 inputs={inputsFilter}
//             />
//         </div>
//     );
// };

// export default ProductList;

const defaultValues = {};

const CompanyList: React.FC<IFormSettinsProps> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentListComponent>(null);

    const columnsTable = React.useMemo<ColumnDef<object>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {row.original?.description}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Matriz
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {row.original?.parent?.description}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() =>
                                refForm.current?.handleEdit(row.original.id)
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm.current?.setIdDelete(row.original.id);
                                refForm.current?.setOpenModalDelete(true);
                            }}>
                            <IconComponent icon={icons.Delete} />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const QUERY_DEFAULT = `page=1&limit=${rowsPerPageOptions[0]}`;

    const inputsFilter = React.useMemo<IFormInputPropsFilter[]>(
        () => [
            {
                typeInput: 'text',
                name: 'company.description',
                control: null,
                label: 'Descrição',
                setValue: null,
                size: 'small',
                variant: 'standard',
                handleOnKeyPress: (data: any, name?: string) => {
                    if (data.charCode === 13 && name) {
                        refForm?.current?.handleByOnKeyPressEnterNewQuery(
                            data.target.value,
                            name,
                        );
                    }
                },
            },
        ],
        [],
    );

    return (
        <ListComponet
            settings={settings}
            defaultValues={defaultValues}
            columnsTable={columnsTable}
            inputsFilter={inputsFilter}
            mainInputsFilter={[]}
            QUERY_DEFAULT={QUERY_DEFAULT}
            ref={refForm}
        />
    );
};

export default CompanyList;
